<template>
<el-row class="intro-chart-wrapper">
  <el-col :lg="6" :md="12">
    <div class="box-wrapper">
      <div class="box">
        <div class="intro">
          <img src="@/assets/img/chart/intro_cart01.png" />
        </div>
      </div>
    </div>
  </el-col>
  <el-col :lg="6" :md="12">
    <div class="box-wrapper">
      <div class="box">
        <div class="intro"><img src="@/assets/img/chart/intro_cart02.png" /></div>
      </div>
    </div>
  </el-col>
  <el-col :lg="6" :md="12">
    <div class="box-wrapper">
      <div class="box">
        <div class="intro"><img src="@/assets/img/chart/intro_cart03.png" /></div>
      </div>
    </div>
  </el-col>
  <el-col :lg="6" :md="12">
    <div class="box-wrapper">
      <div class="box">
        <div class="intro"><img src="@/assets/img/chart/intro_cart04.png" /></div>
      </div>
    </div>
  </el-col>
</el-row>
</template>

<script>
export default {
  name: 'WChartTemplateView',
};
</script>

<style lang="scss" scoped>
.chart-desc-box {
  height: 402px;
  width: 100%;
  background: #f7f7f8; //$vlightgray
  border: 1px dashed #dcdcdc;
  display: flex;
  align-items: center;
  // justify-content: center;

  .desc {
    width: 100%;
    padding: 0 20px 20px;
    .detail {
      color: #666;
    }
  }

  .img-1 {
    background-image: url('../../../../assets/img/chart-template-first.png');
    width: 300px;
    height: 300px;
  }

  .img-2 {
    background-image: url('../../../../assets/img/chart-template-second.png');
    width: 300px;
    height: 300px;
  }

  .img-3 {
    background-image: url('../../../../assets/img/chart-template-third.png');
    width: 300px;
    height: 300px;
  }

  .img-4 {
    background-image: url('../../../../assets/img/chart-template-four.png');
    width: 300px;
    height: 300px;
  }
}

.center-align {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/chart/components/view/ChartTemplateView.vue